import { H1 as BluBlocksH1 } from "@bluframe/blublocks";
import styled from "styled-components";
export const Wrapper = styled.div `
  display: grid;
  row-gap: 20px;
`;
export const H1 = styled(BluBlocksH1) `
  font-size: 20px;
`;
